import { render, staticRenderFns } from "./sacrificeManage.vue?vue&type=template&id=8c7a88d2&scoped=true&"
import script from "./sacrificeManage.vue?vue&type=script&lang=js&"
export * from "./sacrificeManage.vue?vue&type=script&lang=js&"
import style0 from "./sacrificeManage.vue?vue&type=style&index=0&id=8c7a88d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7a88d2",
  null
  
)

export default component.exports